import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Diagnosis } from '../../components/AssessmentAndPlan/types'
import { ChatbotState } from '../../model/chatbot'

const initialState: ChatbotState = {
	diagnosi: undefined,
	clipboard: undefined,
}

export const slice = createSlice({
	name: 'chatbot',
	initialState,
	reducers: {
		setICDToRecommend: (
			state,
			{ payload }: PayloadAction<Diagnosis | undefined>,
		) => {
			state.diagnosi = payload
		},
		setClipboardData: (
			state,
			{ payload }: PayloadAction<string | undefined>,
		) => {
			state.clipboard = payload
		},
	},
})

export default slice.reducer
